import { securityApi, RequestApi } from 'helpers';

import { DELETE_SESSION_TIMEOUT_MS } from 'constants/common';

const getUserAvailablePermissions = (companyUserId: string) => {
  return securityApi.get(
    `/companyusers/${companyUserId}/availablepermissions?IncludeDirectPermissions=true&IncludeGroupPermissions=true&IncludeScopePermissions=true&MakeItFlat=true`,
  );
};

const getAvailablePermissionsByUserId = (userId: string) => {
  return securityApi.get(
    `users/${userId}/availablepermissions?IncludeDirectPermissions=true&IncludeGroupPermissions=true&IncludeScopePermissions=true&MakeItFlat=true`,
  );
};

const authenticate = (data: any) => {
  return securityApi.post(`/users/authenticate`, data);
};

const resetPassword = (data: any) => {
  return RequestApi.post(`/users/resetPassword`, data);
};

const confirmResetPassword = (data: any) => {
  return RequestApi.post(`/users/confirmResetPassword`, data);
};

const validateResetPasswordToken = (data: any) => {
  return RequestApi.post(`/users/validateResetPasswordToken`, data);
};

const getUserCompanies = (userId: string) => {
  return RequestApi.get(`/Users/${userId}/Companies`);
};

const initiateAuth = (data: any) => {
  return securityApi.post(`/users/initiateauth`, data);
};

const respondToAuthChallenge = (data: any) => {
  return securityApi.post(`/users/respondtoauthchallenge`, data);
};

const changePasswordWithToken = (data: { accessToken: string; currentPassword: string; newPassword: string }) => {
  return RequestApi.put(`/users/self/changePassword`, data);
};

const changePassword = (
  userId: string,
  data: { currentPassword: string; newPassword: string; languageCode?: string },
) => {
  RequestApi.defaults.headers['Accept-Language'] = data.languageCode || 'en';
  return RequestApi.put(`/users/${userId}/changePassword`, data);
};

const deleteSession = () => {
  return RequestApi.delete(`/users/self/session`, { timeout: DELETE_SESSION_TIMEOUT_MS });
};

export default {
  getUserAvailablePermissions,
  getAvailablePermissionsByUserId,
  authenticate,
  resetPassword,
  confirmResetPassword,
  validateResetPasswordToken,
  getUserCompanies,
  initiateAuth,
  respondToAuthChallenge,
  changePasswordWithToken,
  changePassword,
  deleteSession,
};
